const activeClass = 'menu-open';

// Handle menu toggle.
const toggle = document.querySelector<HTMLInputElement>('nav input');
if (toggle) {
	toggle.addEventListener('change', (event) => {
		const {currentTarget} = event;
		if (!(currentTarget instanceof HTMLInputElement)) {
			return;
		}

		const {checked} = currentTarget;
		document.documentElement.classList.toggle(activeClass, checked);
	});
}

// Close menu when hitting the ESC key.
document.addEventListener('keyup', (event) => {
	if (!(
		document.documentElement.classList.contains(activeClass) &&
		event.key === 'Escape' &&
		toggle
	)) {
		return;
	}

	const changeEvent = new Event('change', {
		bubbles: true,
		cancelable: false,
	});
	toggle.checked = false;
	toggle.dispatchEvent(changeEvent);
});
